<template>
  <div class="navbar">
    <div class="navbar-box">
      <div class="navbar-left">
        <img src="../assets/logo.png" class="logo" @click="$router.push('/')"/>
        <div class="navbar-list">
          <!-- 导航栏循环 -->
          <div class="nav-item" :class="{ active: isActive(item.path) }" v-for="item in navList" :key="item.path"
               @click="!item.icon && goTo(item.path)" @mouseenter="item.icon && (item.show = true)"
               @mouseleave="item.icon && (item.show = false)">
            <img v-if="item.path === '/'" class="nav-item nav-item0" src="@/assets/images/NavBar/navbar-home.svg"
                 alt="">
            {{ $t(item.title) }}

            <!-- icon箭头图表显示 -->
            <i v-if="item.icon" class="el-icon-caret-bottom" :class="{ active: $route.path === item.path }"
               aria-hidden="true"></i>
            <!-- 下拉框：只给 无icon + 当前项show=true 的显示 -->
            <!-- 下拉框 -->
            <transition name="dropdown">
              <div class="dropdown" v-show="item.icon && item.show" @mouseenter="item.show = true"
                   @mouseleave="item.show = false">
                <div class="dropdown-item" @click="goPage(sub.path)" v-for="(sub, index) in item.children" :key="index">
                  <div class="dropdown-item-left">
                    <div class="dropdown-item-left-img"><img v-if="sub.image" :src="sub.image"></div>
                    <span>{{ sub.title }}</span>
                  </div>
                  <div class="dropdown-item-right">
                    <i class="el-icon-right"></i>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div v-if="!isLogin" class="offlogin">
          <div @click="gologin()" class="operat login">Login</div>
          <div @click="goregister()" class="operat register">
            <img src="@/assets/images/NavBar/register.svg" alt="">
            <span>Register</span>
          </div>
        </div>
        <div v-if="isLogin" class="openlogin">
          <div class="operat-item" @click="goCz()">
            {{ $t('index.text4') }}
          </div>
          <div>
            <div class="trigger-box">
              <p class="trigger">
                <i class="el-icon-s-finance"></i>
                {{ $t('coin.asset') }}
                <i class="el-icon-caret-bottom"></i>
              </p>
              <ul>
                <li @click="goPage('/asset')">
                  <img src="@/assets/tu/asset.png" alt="" class="tu">
                  {{ $t('coin.overview') }}
                </li>
                <li @click="goPage('/asset?type=1')">
                  <img src="@/assets/tu/spot.png" alt="" class="tu">
                  {{ $t('coin.spot_account') }}
                </li>
                <li @click="goPage('/asset?type=2')">
                  <img src="@/assets/tu/futures.png" alt="" class="tu">
                  {{ $t('coin.trade_account') }}
                </li>
                <li @click="goPage('/asset?type=3')">
                  <img src="@/assets/tu/options.png" alt="" class="tu">
                  {{ $t('coin.stock_account') }}
                </li>
                <li @click="goPage('/deposit')">
                  <img src="@/assets/tu/deposit.png" alt="" class="tu">
                  {{ $t('coin.deposit') }}
                </li>
                <li @click="goPage('/withdraw')">
                  <img src="@/assets/tu/withdraw.png" alt="" class="tu">
                  {{ $t('coin.withdraw') }}
                </li>
                <li @click="goPage('/transfer')">
                  <img src="@/assets/tu/transfer.png" alt="" class="tu">
                  {{ $t('coin.transfer') }}
                </li>
              </ul>
            </div>
          </div>
          <div class="user-box">
            <p class="user"><i class="el-icon-user-solid"></i></p>
            <ul>
              <li @click="goPage('/user')">
                <img src="@/assets/tu/user.png" alt="" class="tu">
                {{ $t('coin.user') }}
              </li>
              <li @click="goPage('/auth')">
                <img src="@/assets/tu/auth.png" alt="" class="tu">
                {{ $t('auth.text') }}
              </li>
              <li @click="goPage('/invite')">
                <img src="@/assets/tu/yao.png" alt="" class="tu">
                Invite Friends
              </li>
              <li @click="goPage('/addr')">
                <img src="@/assets/tu/addr.png" alt="" class="tu">
                {{ $t('address.text') }}
              </li>
              <li @click="goPage('/bank')">
                <img src="@/assets/tu/bank.png" alt="" class="tu">
                Bank account
              </li>
              <li @click="goPage('/password')">
                <img src="@/assets/tu/password.png" alt="" class="tu">
                {{ $t('pwd.text') }}
              </li>
              <li @click="goPage('/payword')">
                <img src="@/assets/tu/paypass.png" alt="" class="tu">
                {{ $t('pwd.text1') }}
              </li>
              <li @click="doLogout()">
                <img src="@/assets/tu/exit.png" alt="" class="tu">
                Logout
              </li>
            </ul>
          </div>

        </div>
        <div @click="dialogVisible = true" class="operat lang"><img src="@/assets/images/NavBar/lang.svg" alt=""></div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog append-to-body title="Language" :visible.sync="dialogVisible" width="28%">
        <div class="dialog-box">
          <div @click="toggleLang('en')" class="dialog-item" :class="{ Langcolor: Langcolor == 'en' }">English</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  props: {},
  data() {
    return {
      dialogVisible: false,
      Langcolor: 'en',
      navList: [
        {title: "Home", path: "/"},// 没有 icon
        {title: "Markets", path: "/market"},// 没有 icon
        {title: "Spot", path: "/spot"},// 没有 icon
        {title: "Futures", path: "/futures"},// 没有 icon
        {title: "Stock", path: "/stock"},// 没有 icon
        {title: "Forex", path: "/forex"},// 没有 icon
        {title: "ETF", path: "/fund"},// 没有 icon
        {title: "Block Trade", path: "/block"},// 没有 icon
        {title: "IPO", path: "/ipo"},// 没有 icon
        {title: "Vote", path: "/vote"},// 没有 icon
      ]
    };
  },

  methods: {
    // 判断当前路由是否激活
    isActive(path) {
      return this.$route.fullPath === path || this.$route.path === path;
    },
    goCz() {
      this.$router.push('/deposit');
    },
    // 跳转 + 防重复报错
    goTo(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
    goPage(path) {
      this.$router.push(path)
    },
    doLogout() {
      this.$message({
        message: this.$t('common.success'),
        type: 'success'
      });
      this.$store.dispatch('doLogout')
      this.$router.push("/")
    },
    gologin() {
      this.$router.push("/login")
    },
    goregister() {
      this.$router.push("/reg")
    },
    // 切换语言
    toggleLang(lang) {
      this.Langcolor = lang
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.$message({
        message: this.$t('common.success'),
        type: 'success'
      });
      this.dialogVisible = false
    }
  },
  computed: {
    isLogin() {
      // 取本地存储的token，有值就是已登录
      return !!localStorage.getItem('token')
    }
  },
}
</script>

<style scoped lang="less">
.navbar {
  color: #fff;
  width: 100%;
  background: #000;
  position: fixed;
  top: 0;
  border-bottom: 0px solid rgb(15, 17, 18);
  cursor: pointer;
  z-index: 999;
}

.navbar-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 65px;
}

.navbar .navbar-left {
  display: flex;
  align-items: center;
}

.navbar .navbar-left .logo {
  height: 60px;
}

.navbar .navbar-left .navbar-list {
  display: flex;
  align-items: center;
  padding: 0px 16px;
}

.navbar .navbar-left .navbar-list .nav-item {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  margin-right: 36px;
}

.navbar .navbar-left .navbar-list .nav-item i {
  margin-left: 2px;
}

.navbar .navbar-left .navbar-list .nav-item.active {
  color: #8ddf29;
}

.navbar .navbar-left .navbar-list .nav-item0 {
  margin-right: 8px;
  width: 20px;
  height: 20px;
}

.navbar .nav-right {
  display: flex;
  align-items: center;
  padding: 0px 16px;
}

.offlogin {
  display: flex;
  align-items: center;
}

.openlogin {
  display: flex;
  align-items: center;
}

.operat-item {
  border: 1px solid #4d4d4d;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  margin-right: 24px;
  padding: 5px 12px;
}

.trigger {
  display: flex;
  align-items: center;
  padding: 8px 12px;
}

.trigger i {
  display: flex;
  align-items: center;
  justify-content: center;
}

.trigger i:first-child {
  width: 22px;
  height: 22px;
  margin-right: 4px;
  background-color: #fff;
  color: #141717;
  border-radius: 50%;
}

.trigger i:last-child {
  width: 22px;
  height: 22px;
  margin-left: 4px;
}

.trigger-box {
  position: relative;
}

.trigger-box:hover ul {
  display: block;
  background: #0f1112;
}

.trigger-box ul {
  display: none;
  flex-direction: column;
  position: absolute;
  top: calc(100% + 8px);
  right: 0%;
  border: 1px solid #4d4d4d;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
  padding: 8px 0px;
  border-radius: 4px;
  min-width: 200px;
}

.trigger-box::after {
  min-width: 100px;
  content: '';
  position: absolute;
  right: 0;
  height: 20px;
  top: 100%;
  background: transparent;
}

.trigger-box ul li {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  width: 100%;
}

.trigger-box ul li:hover {
  background: #15181a;
}

.trigger-box ul li i {
  margin-right: 12px;
  font-size: 18px;
}


.user {
  padding: 8px 12px;
}

.user i {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  font-size: 18px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #141717;
}

.user-box {
  position: relative;
}

.user-box:hover ul {
  display: block;


}

.user-box ul {
  background: #0f1112;
  display: none;
  flex-direction: column;
  position: absolute;
  top: calc(100% + 8px);
  right: 0%;
  border: 1px solid #4d4d4d;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
  padding: 8px 0px;
  border-radius: 4px;
  min-width: 200px;
}

.user-box::after {
  min-width: 100px;
  content: '';
  position: absolute;
  right: 0;
  height: 20px;
  top: 100%;
  background: transparent;
}

.user-box ul li {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  width: 100%;
}

.user-box ul li:hover {
  background: #15181a;
}

.user-box ul li i {
  margin-right: 12px;
  font-size: 18px;
}


.drop-menu {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  min-width: 120px;
  z-index: 999;
}

.drop-menu li {
  padding: 10px 15px;
  white-space: nowrap;
}

.drop-menu li:hover {
  background: #f5f5f5;
}

.drop-menu li a {
  color: #333;
}


.navbar .nav-right .operat {
  display: flex;
  align-items: center;
}

.navbar .nav-right .login {
  background: #0f1112;
  border: 1px solid #0f1112;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  padding: 0px 16px;
  margin-right: 20px;
}

.navbar .nav-right .login img {
  width: 22px;
  height: 22px;
  margin-right: 2px;
}

.navbar .nav-right .register {
  display: flex;
  align-items: center;
  color: #000;
  background: #abe127;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  margin-left: 12px;
  padding: 6px 16px;
}

.navbar .nav-right .lang {
  margin-left: 20px;
}

.navbar .nav-right .lang img {
  width: 26px;
}

/* 下拉项 */

.dropdown {
  z-index: 2027;
  position: absolute;
  top: 23px;
  transform: translateX(-40%);
  min-width: 260px;
  margin-top: 12px;
  background: #0f1112;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  padding: 15px 0;
  line-height: 1.4;
  transform-origin: center top;
}

.dropdown .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;
  text-align: justify;
  padding: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  height: 1.4;
  transition: background 0.2s;

}

.dropdown .dropdown-item .dropdown-item-left {
  display: flex;
  align-items: center;
}

.dropdown .dropdown-item .dropdown-item-left .dropdown-item-left-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
}

.dropdown .dropdown-item .dropdown-item-left img {
  width: 16px;
  height: 16px;
}

.dropdown .dropdown-item .dropdown-item-left span {
  margin-left: 9px;
}

.dropdown .dropdown-item .dropdown-item-right {
  opacity: 0;
  /* 隐藏 */
}

.dropdown .dropdown-item:hover .dropdown-item-right {
  opacity: 1;
  /* 显示 */
}

.dropdown .dropdown-item .dropdown-item-right i {
  width: 16px;
  height: 16px;
}

.dropdown-item:hover {
  background: #15181a !important;
}

/* 动画：缓慢出现 + 缓慢消失 */
.dropdown-enter-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

::v-deep .el-dialog {
  padding: 16px 40px 24px;
  background-color: #242424;
}

::v-deep .el-dialog__header {
  padding: 0px 0px 8px 0px;
}

::v-deep .el-dialog__title {
  color: #fff;
  margin-left: 2px;
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 8px;
  border-bottom: 2px solid #8ddf29;
}

::v-deep .el-dialog__body {
  padding: 0;
}

.dialog-box {
  margin-top: 15px;

  gap: 16px;
  display: flex;
  flex-wrap: wrap;
  display: flex;

}

.dialog-item {
  padding: 12px;
  flex: 0 0 calc(25% - 12px);
  color: #fff;
  cursor: pointer;
}

.Langcolor {
  color: #8ddf29;
}

.tu {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
